import DataTableSync from 'datatablesync';
import store from '@/store';

const DATA_TABLE_SYNC_FACTORY = DataTableSync(store);
export default DATA_TABLE_SYNC_FACTORY.createDataTableSyncInstance;
